import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=b54aaeb2&scoped=true&"
import script from "./PageHeading.vue?vue&type=script&lang=js&"
export * from "./PageHeading.vue?vue&type=script&lang=js&"
import style0 from "./PageHeading.vue?vue&type=style&index=0&id=b54aaeb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54aaeb2",
  null
  
)

/* custom blocks */
import block0 from "@/locales/components/PageHeading.json?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Ccomponents%5CPageHeading.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports